module.exports = __webpack_public_path__ + "static/media/wind.cf2ddcf8.svg";